<template>
  <div>
    <div
      v-if="currentBillingMethodId && status === billingStatusAtivo && company.seller"
      class="no-pending-message"
    >
      <b-message type="is-success" has-icon>
        Você <b>não</b> possui pendências financeiras e pode usufruir da plataforma normalmente.
      </b-message>
    </div>
    <div v-if="company.status !== 'CADASTRADA'" style="display: flex; justify-content: end">
      <p class="credit-info">Créditos disponíveis: {{ availableCredits }}</p>
    </div>
    <b-loading is-full-page :active="loading.general" can-cancel></b-loading>
    <div class="pricing-table">
      <div
        :class="[
          'pricing-plan',
          selectedBadge(JSON.parse(selectedMonthlyPlan).id) ? 'featured' : '',
        ]"
      >
        <div class="plan-title">Mensalidade</div>
        <div class="plan-price">R$ {{ selectedMonthlyPrice }},00</div>
        <div class="plan-duration">Escolha a periodicidade</div>
        <select v-model="selectedMonthlyPlan" @change="selectMonthlyPrice">
          <option
            v-for="(option, i) in monthlyPlans"
            :key="i"
            :value="JSON.stringify({ value: option.value, id: option.id })"
          >
            {{ getOptionLabel(option) }}
          </option>
        </select>
        <div v-if="finishDate && status === billingStatusAtivo" class="plan-duration">
          Seu plano irá vencer em: {{ selectedMonthlyFinishDate }}
        </div>

        <button
          @click.prevent.stop="selectBillingMethod(JSON.parse(selectedMonthlyPlan).id)"
          class="sign-up-btn"
        >
          Assinar
        </button>
      </div>

      <!-- <div
        v-for="plan in othersPlans"
        :key="plan.id"
        :class="['pricing-plan', selectedBadge(plan.id) ? 'featured' : '']"
      > -->
      <!-- <div v-if="plan.type === 'PERCENTUAL'" class="badge">Mais vendido</div> -->
      <!-- <div class="plan-title">
          {{ getPlanTitle(plan.type) }}
        </div>
        <div class="plan-price">
          {{ plan.type === 'PERCENTUAL' ? '%' : `R$ ${plan.value},00` }}
        </div>
        <div class="plan-duration">
          <p>5% Pregões Eletrônicos</p>
          <p>5% Concorrências Eletrônicas</p>
          <p>2% Dispensas</p>
        </div>
        <ul class="plan-features">
          <li>Cobrança percentual</li>
          <li>Taxa sobre cada participação</li>
        </ul>
        <button @click.prevent.stop="selectBillingMethod(plan.id)" class="sign-up-btn">
          Assinar
        </button> -->
      <!-- </div> -->

      <div
        :class="[
          'pricing-plan',
          selectedBadge(JSON.parse(selectedAvulsoPlan).id) ? 'featured' : '',
        ]"
      >
        <div class="plan-title">Avulso</div>
        <div class="plan-price">R$ {{ selectedAvulsoPrice }},00</div>
        <div class="plan-duration">Escolha a quantidade de créditos</div>
        <select v-model="selectedAvulsoPlan" @change="selectAvulsoPrice">
          <option
            v-for="(option, i) in avulsoPlans"
            :key="i"
            :value="JSON.stringify({ value: option.value, id: option.id })"
          >
            {{ getOptionLabel(option) }}
          </option>
        </select>
        <button
          @click.prevent.stop="selectBillingMethod(JSON.parse(selectedAvulsoPlan).id)"
          class="sign-up-btn"
        >
          Assinar
        </button>
      </div>
    </div>
    <b-message class="payment-tip" type="is-warning" has-icon>
      <div class="tip-title">
        <b>Atenção quanto à forma de pagamento</b>
      </div>

      <div class="tip-body">
        <p>
          Os pagamentos realizados por <b>boleto bancário</b> podem demandar até
          <b>48 horas úteis</b> para compensação.
        </p>
        <p>
          Para situações em que o prazo para inserção de propostas é curto, recomendamos a
          utilização de
          <b>Pix</b> ou <b>cartão de crédito</b>, cuja compensação ocorre em até <b>2 horas</b>.
        </p>
      </div>

      <p class="tip-footnote">
        Dessa forma, o acesso à plataforma será liberado com maior celeridade, reduzindo o risco de
        perda de prazo.
      </p>
    </b-message>
    <p v-if="paymentReminder" class="payment-reminder">
      Finalize o pagamento clicando
      <a href="#" @click.prevent="gerarLinkERedirecionar">AQUI</a> para liberar o acesso à
      plataforma.
    </p>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { BILLING_STATUS, BILLING_TYPE } from '@/utils/enumerados';

export default {
  data() {
    const loading = {
      general: false,
    };
    return {
      availableCredits: 0,
      loading,
      selectedAvulsoPrice: '',
      selectedAvulsoPlan: '',
      selectedAvulsoPlanID: '',
      selectedMonthlyPrice: '',
      selectedMonthlyPlan: '',
      selectedMonthlyPlanID: '',
      selectedMonthlyFinishDate: '',
    };
  },
  computed: {
    ...mapState('companies', ['company']),
    ...mapState('companyBilling', [
      'currentBillingMethodId',
      'status',
      'finishDate',
      'companyCredits',
    ]),
    ...mapState('billingMethods', ['billingMethods']),
    monthlyPlans() {
      return (this.billingMethods || []).filter(m => m.type === BILLING_TYPE.MONTHLY);
    },
    avulsoPlans() {
      return (this.billingMethods || []).filter(m => m.type === BILLING_TYPE.AVULSA);
    },
    othersPlans() {
      return (this.billingMethods || []).filter(m => m.type === BILLING_TYPE.PERCENTUAL);
    },
    currentPlan() {
      return (this.billingMethods || []).find(m => m.id === this.currentBillingMethodId) || null;
    },
    paymentReminder() {
      return (
        (this.status &&
          (this.status === BILLING_STATUS.AGUARDANDO || this.status === BILLING_STATUS.SUSPENSO) &&
          this.company?.seller) ||
        (this.currentBillingMethodId && this.company?.status === 'CADASTRADA')
      );
    },
    billingStatusAtivo() {
      return BILLING_STATUS.ATIVO;
    },
  },
  methods: {
    ...mapActions('billingMethods', ['fetchBillingMethods']),
    ...mapActions('companyBilling', [
      'chargePayment',
      'chooseBillingMethod',
      'updateBillingMethod',
      'getCompanyCurrentBillingMethod',
      'getCompanyCredits',
    ]),
    async gerarLinkERedirecionar() {
      try {
        this.loading.general = true;
        const invoiceUrl = await this.chargePayment({
          companyId: this.company.id,
        });
        if (invoiceUrl) {
          window.location.href = invoiceUrl;
        } else {
          this.$alerta('Não foi possível obter o link de pagamento.', 'is-danger');
        }
      } catch (error) {
        this.$alerta('Erro ao tentar gerar link de pagamento.', 'is-danger');
      } finally {
        this.loading.general = false;
      }
    },
    async loadData() {
      try {
        this.loading.general = true;

        await Promise.all([
          this.fetchBillingMethods(),
          this.getCompanyCurrentBillingMethod(this.company.id),
          this.getCompanyCredits(this.company.id),
        ]);
      } catch (error) {
        this.$alerta('Erro ao buscar dados', 'is-danger');
      } finally {
        this.loading.general = false;
      }
    },
    getOptionLabel(option) {
      if (option.duration === '90d') {
        return `Trimestral - R$ ${option.value},00`;
      }
      if (option.duration === '180d') {
        return `Semestral - R$ ${option.value},00`;
      }
      if (option.duration === '365d') {
        return `Anual - R$ ${option.value},00`;
      }
      if (option.duration === '1u') {
        return `1 crédito - R$ ${option.value},00`;
      }
      if (option.duration === '5u') {
        return `5 créditos - R$ ${option.value},00`;
      }
      if (option.duration === '10u') {
        return `10 créditos - R$ ${option.value},00`;
      }
      return '';
    },
    getPlanTitle(type) {
      if (type === BILLING_TYPE.PERCENTUAL) return 'Percentual';
      if (type === BILLING_TYPE.AVULSA) return 'Avulso';
      return '';
    },
    selectAvulsoPrice(event) {
      const targetValue = JSON.parse(event.target.value);
      this.selectedAvulsoPrice = targetValue.value;
      this.selectedAvulsoPlanID = targetValue.id;
    },
    selectMonthlyPrice(event) {
      const targetValue = JSON.parse(event.target.value);
      this.selectedMonthlyPrice = targetValue.value;
      this.selectedMonthlyPlanID = targetValue.id;
      this.selectedMonthlyFinishDate = '';
    },
    async selectBillingMethod(id) {
      this.loading.general = true;
      if (this.currentBillingMethodId === id) {
        this.loading.general = false;
        return;
      }

      try {
        if (this.currentBillingMethodId) {
          await this.updateBillingMethod({ billingMethodId: id, companyId: this.company.id });
        } else {
          await this.chooseBillingMethod({ billingMethodId: id, companyId: this.company.id });
        }

        await this.getCompanyCurrentBillingMethod(this.company.id);
      } catch (error) {
        if (error?.errors[0]?.code === 'unable-to-finish-billing-method') {
          this.$alerta(
            'Atualização indisponível! Forma de cobrança ainda dentro do prazo vigente!',
            'is-danger',
          );
        } else {
          this.$alerta('Erro ao atualizar forma de cobrança', 'is-danger');
        }
      } finally {
        this.loading.general = false;
      }
    },
    selectedBadge(id) {
      return this.currentBillingMethodId === id;
    },
    isMonthlyPlan() {
      return this.currentPlan?.type === BILLING_TYPE.MONTHLY;
    },
    isAvulsoPlan() {
      return this.currentPlan?.type === BILLING_TYPE.AVULSA;
    },
  },
  async created() {
    const formatDate = dateStr => {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    };
    await this.loadData();
    this.selectedMonthlyFinishDate = formatDate(this.finishDate);
    this.availableCredits = this.companyCredits ? this.companyCredits : 0;

    this.selectedAvulsoPrice = this.isAvulsoPlan()
      ? this.currentPlan?.value
      : this.avulsoPlans[0]?.value;
    this.selectedAvulsoPlan = this.isAvulsoPlan()
      ? JSON.stringify({ value: this.currentPlan?.value, id: this.currentPlan?.id })
      : JSON.stringify({ value: this.avulsoPlans[0]?.value, id: this.avulsoPlans[0]?.id });
    this.selectedMonthlyPrice = this.isMonthlyPlan()
      ? this.currentPlan?.value
      : this.monthlyPlans[0]?.value;
    this.selectedMonthlyPlan = this.isMonthlyPlan()
      ? JSON.stringify({ value: this.currentPlan?.value, id: this.currentPlan?.id })
      : JSON.stringify({ value: this.monthlyPlans[0]?.value, id: this.monthlyPlans[0]?.id });
  },
};
</script>

<style scoped>
body {
  font-family: Arial, sans-serif;
  background-color: #f4f4f4;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
}

.credit-info {
  font-family: var(--fonte-principal);
  font-weight: 900;
  color: var(--cor-primaria);
  background-color: #f4f6fa;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 16px;
  display: inline-block;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.no-pending-message {
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  background-color: #e6ffed;
  border: 1px solid #c8e6c9;
  color: #2e7d32;
  font-size: 0.95rem;
  text-align: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}
.payment-reminder {
  color: #d9534f;
  font-weight: bold;
  margin-top: 10px;
  text-align: center;
}
.pricing-table {
  display: flex;
  gap: 20px;
  justify-content: center;
}
.pricing-plan {
  position: relative;
  background-color: rgba(255, 255, 255, 0.568);
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
  width: 280px;
  transition: transform 0.3s;
}
.pricing-plan:hover {
  transform: scale(1.05);
}
.pricing-plan.featured {
  border: 2px solid #007bff;
}

.plan-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}
.plan-price {
  font-size: 36px;
  font-weight: bold;
  margin: 10px 0;
}
.plan-duration {
  font-size: 16px;
  color: gray;
  display: block;
  margin-bottom: 20px;
}
.plan-features {
  list-style-type: none;
  padding: 0;
  margin-bottom: 20px;
}
.plan-features li {
  margin-bottom: 10px;
}
.sign-up-btn {
  display: inline-block;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  cursor: pointer;
}
.sign-up-btn:hover {
  background-color: #0056b3;
}
.sign-up-btn.avulso-btn {
  background-color: #666;
}
.sign-up-btn.avulso-btn:hover {
  background-color: #444;
}
select {
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 16px;
}
.badge {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #ff9800;
  color: white;
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 4px;
}
.payment-tip {
  margin-top: 12px;
  text-align: center;
  border-radius: 10px;
}

.tip-title {
  font-size: 1.05rem;
  margin-bottom: 6px;
}

.tip-body {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.method-sep {
  opacity: 0.5;
}

.method-pill {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.9rem;
  line-height: 1;
  background: #f1f5f9; /* base neutra */
  border: 1px solid #e2e8f0;
}

.method-pill.is-boleto {
  background: #fff1f2; /* leve vermelho/rosa */
  border-color: #fecdd3;
  color: #b91c1c;
}

.method-pill.is-pix {
  background: #ecfeff; /* leve ciano */
  border-color: #a5f3fc;
  color: #0e7490;
}

.method-pill.is-card {
  background: #eef2ff; /* leve índigo */
  border-color: #c7d2fe;
  color: #3730a3;
}

.tip-footnote {
  margin-top: 8px;
  font-size: 0.9rem;
}
</style>
